export default new class Header {
    init() {
		this.initHeader();
	}

	// Scroll : add or remove class "scrolled" in the "js-header"
    initHeader() {
		let scrollPos = window.scrollY;
		const header = document.querySelector('.js-header');
		const scrollChange = 100;

		if (header) {
			const addClassOnScroll = function () {
				header.classList.add('scrolled');
			}
			const removeClassOnScroll = function () {
				header.classList.remove('scrolled');
			}
			window.addEventListener('scroll', function () {
				scrollPos = window.scrollY;

				if (scrollPos >= scrollChange) { addClassOnScroll() } else { removeClassOnScroll() }
			});
		}
	}
}